module.exports = __webpack_public_path__ + "img/图像 11@2x.983146ed.webp";